import { render } from "./Header.vue?vue&type=template&id=2d25d87e&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=2d25d87e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2d25d87e"

export default script